module.exports = __webpack_public_path__ + "static/media/PC6-6.57c10319.jpg";